import CategoriaFormularioService from 'src/modules/categoriaFormulario/categoriaFormularioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'CATEGORIAFORMULARIO_VIEW';

const categoriaFormularioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormularioViewActions.FIND_STARTED,
      });

      const record = await CategoriaFormularioService.find(id);

      dispatch({
        type: categoriaFormularioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormularioViewActions.FIND_ERROR,
      });

      getHistory().push('/categoria-formulario');
    }
  },
};

export default categoriaFormularioViewActions;
